/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from '@/shared/api/axios-client'
import type { GetUsersRecruitersQueryResponse, GetUsersRecruiters400 } from '../entities/GetUsersRecruiters'
import type { RequestConfig, ResponseErrorConfig } from '@/shared/api/axios-client'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getUsersRecruiters } from '../api/getUsersRecruiters'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getUsersRecruitersQueryKey = () => [{ url: '/users/recruiters' }] as const

export type GetUsersRecruitersQueryKey = ReturnType<typeof getUsersRecruitersQueryKey>

export function getUsersRecruitersQueryOptions(config: Partial<RequestConfig> & { client?: typeof client } = {}) {
  const queryKey = getUsersRecruitersQueryKey()
  return queryOptions<GetUsersRecruitersQueryResponse, ResponseErrorConfig<GetUsersRecruiters400>, GetUsersRecruitersQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal
      return getUsersRecruiters(config)
    },
  })
}

/**
 * @description Получение вербовщиков
 * @summary Получение вербовщиков
 * {@link /users/recruiters}
 */
export function useGetUsersRecruiters<
  TData = GetUsersRecruitersQueryResponse,
  TQueryData = GetUsersRecruitersQueryResponse,
  TQueryKey extends QueryKey = GetUsersRecruitersQueryKey,
>(
  options: {
    query?: Partial<QueryObserverOptions<GetUsersRecruitersQueryResponse, ResponseErrorConfig<GetUsersRecruiters400>, TData, TQueryData, TQueryKey>> & {
      client?: QueryClient
    }
    client?: Partial<RequestConfig> & { client?: typeof client }
  } = {},
) {
  const { query: { client: queryClient, ...queryOptions } = {}, client: config = {} } = options ?? {}
  const queryKey = queryOptions?.queryKey ?? getUsersRecruitersQueryKey()

  const query = useQuery(
    {
      ...(getUsersRecruitersQueryOptions(config) as unknown as QueryObserverOptions),
      queryKey,
      ...(queryOptions as unknown as Omit<QueryObserverOptions, 'queryKey'>),
    },
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<GetUsersRecruiters400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}